/**
 * 企微认证业务层 — 对接 Apifox scj 企业微信认证 Controller
 */

import { authService } from '@/services/artApi';
import { unwrapApiResult } from '@/utils/artMapper';
import { mapAuthResponseToSession } from '@/utils/authMapper';
import { setAuthToken, clearAuthToken } from '@/utils/authToken';

function assertAuthSession(session) {
  if (!session?.token) {
    throw new Error('认证成功但未返回 Token');
  }
  return session;
}

/** GET /api/wechatwork/app/auth/getUserInfoByApiCode */
export async function loginByWeComCode(code) {
  if (!code) throw new Error('缺少企微登录 code');
  const payload = await authService.getUserInfoByApiCode(code);
  const session = assertAuthSession(mapAuthResponseToSession(unwrapApiResult(payload) || {}));
  setAuthToken(session.token);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('cdp_role', session.loginRole);
    localStorage.setItem('cdp_raw_roles', JSON.stringify(session.roles || []));
    localStorage.setItem('cdp_user', JSON.stringify({
      userId: session.userId,
      userName: session.userName,
      weChatWorkAccount: session.weChatWorkAccount,
      roles: session.roles,
      primaryRole: session.primaryRole,
      roleTitle: session.roleTitle,
      loginRole: session.loginRole,
    }));
  }
  return session;
}

/** GET /api/wechatwork/app/auth/test — 开发/快捷授权用模拟登录 */
export async function loginByTestAuth() {
  const payload = await authService.test();
  const session = assertAuthSession(mapAuthResponseToSession(unwrapApiResult(payload) || {}));
  setAuthToken(session.token);
  return session;
}

/** GET /api/wechatwork/app/auth/test1 — 校验当前 JWT 是否有效 */
export async function checkCurrentAuth() {
  const payload = await authService.test1();
  return {
    ok: payload?.success !== false,
    raw: payload,
  };
}

export function logoutAuth() {
  clearAuthToken();
}
